/* eslint-disable no-return-assign */
import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Flex, IconButton, Img, Text } from '@chakra-ui/react'
import { iCardAvaliacaoResponse, iCardCarouselResponse } from '../..'
import { FaChartPie, FaClipboardList, FaClock, FaCloudDownloadAlt, FaComments, FaEnvelope, FaEye, FaFileCsv, FaPeopleArrows, FaStreetView, FaTachometerAlt, FaUserCheck, FaUserClock, FaUsers, FaWpforms } from 'react-icons/fa'
import { MdChevronLeft, MdChevronRight, MdSend } from 'react-icons/md'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalAvaliacoes } from '../ModalAvaliacoes'
import { useNavigate } from 'react-router'
import { parseJwt } from '../../../../../services/token'
import { urlApi } from '../../../../../services/appApi'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { GetNomeItemFeedback, ObterToken } from '../../../../../Utils/Helper'
import { iNomeId } from '../../../../../interfaces'
import { ModalReunioes } from '../ModalReunioes'
import { GoGraph } from 'react-icons/go'
import { BsCalendarCheck } from 'react-icons/bs'
import { AiOutlineTable } from 'react-icons/ai'
import { ModalCalibracoes } from '../ModalCalibracoes'
const IconeOutros = 'https://sigah.blob.core.windows.net/assets/front/IconeOutrosAzul.svg'
const IconeLider = 'https://sigah.blob.core.windows.net/assets/front/IconeLiderAzul.svg'

interface CarouselProps {
  items: iCardCarouselResponse[]
  height?: number
  feedbackId: string
  ordem: number
  onChangeOrdem: (ordem: number) => void
}

export const Carousel: React.FC<CarouselProps> = ({ items, height = 300, feedbackId, onChangeOrdem, ordem }) => {
  const [AvaliacoesIndividuais, setAvaliacoesIndividuais] = useState<iCardAvaliacaoResponse[]>()
  const [Reunioes, setReunioes] = useState<iNomeId[]>()
  const [Calibracoes, setCalibracoes] = useState<iNomeId[]>()
  const [IsForm, setIsForm] = useState(false)
  const [IsPDI, setIsPDI] = useState(false)
  const navigate = useNavigate()
  const redirectPage = (url: string): any => { window.location.href = url }

  const handleNext = (): void => onChangeOrdem((ordem + 1) % items.length)
  const handlePrev = (): void => onChangeOrdem((ordem - 1 + items.length) % items.length)

  function GetIconByTipoItem(tipo: number, size?: number): any {
    switch (tipo) {
      case 0:
      case 3:
      case 4:
        return <FaStreetView size={size} color={'var(--Rosa)'}/>

      case 2:
        return <FaClock size={size} color={'var(--Rosa)'}/>

      case 6:
        return <GoGraph size={size} color={'var(--Rosa)'}/>

      case 5:
      case 10:
        return <FaClipboardList size={size} color={'var(--Rosa)'}/>

      case 15:
        return <FaComments size={size} color={'var(--Rosa)'}/>

      case 13:
        return <FaTachometerAlt size={size} color={'var(--Rosa)'}/>

      case 8:
      case 11:
        return <FaPeopleArrows size={size} color={'var(--Rosa)'}/>

      case 9:
        return <FaUserClock size={size} color={'var(--Rosa)'}/>

      case 1:
      case 14:
        return <BsCalendarCheck size={size} color={'var(--Rosa)'}/>

      case 7:
      case 12:
        return <AiOutlineTable size={size} color={'var(--Rosa)'}/>
    }

    return <FaPeopleArrows/>
  }

  function getIcon(tipo: number): any {
    switch (tipo) {
      case 0: return <FaUserCheck size={34} style={{ marginRight: '.25rem' }} />
      case 2: return <FaPeopleArrows size={34} style={{ marginRight: '.25rem' }} />
      case 1: return <Img width={34} height={34} marginRight={'.25rem'} color={'var(--Blue)'} src={IconeLider} />
      case 3: return <FaUsers size={34} style={{ marginRight: '.25rem' }} />
      case 4: return <img src={IconeOutros} width={34} height={34} style={{ marginRight: '.25rem' }}/>
      case 6: return <FaPeopleArrows size={34} style={{ marginRight: '.25rem' }} />
      default: return <FaUserCheck size={34} style={{ marginRight: '.25rem' }} />
    }
  }

  function getName(tipo: number): any {
    switch (tipo) {
      case 0:
        return 'Autoavaliação'
      case 2:
        return 'Pares'
      case 1:
        return 'Gestor'
      case 3:
        return 'Liderados'
      case 4:
        return 'Outros'
      case 6:
        return 'Alta liderança'
      default:
        return ''
    }
  }

  function ReturnItem(item: iCardCarouselResponse): any {
    const modoPesquisa = item.tipo === 3 ? 'Quantitativa' : item.tipo === 4 ? 'Indicativa' : ''

    switch (item.tipo) {
      case 3:
      case 4:
        return <Flex
          minW={'100%'}
          h={`${height}px`}
          transition='all 0.3s ease'
          border='1px solid var(--Azul)'
          borderRadius={'.25rem'}
          bg='white'
          flexDir={'column'}
          gap={'.75rem'}
          p={'.75rem 4.5rem'}
          boxSizing={'border-box'}
        >
          <Flex justifyContent={'space-between'} w={'full'}>
            <Flex gap={'.625rem'} alignItems={'center'}>
              {GetIconByTipoItem(item.tipo, 24)}
              <Flex flexDir={'column'} lineHeight={'14px'}>
                <h3>{item.cardAvaliacao.nome}</h3>
                <Text fontSize={'13px'} fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
              </Flex>
            </Flex>
            <Flex pt={'.325rem'} gap={'.325rem'} alignItems={'center'} h={'fit-content'} fontSize={'14px'} color={item.cardAvaliacao.status === 'Aguardando início' ? 'var(--c6)' : item.cardAvaliacao.status === 'Concluída' ? 'var(--Green2)' : item.cardAvaliacao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
              <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.cardAvaliacao.status === 'Aguardando início' ? 'var(--c6)' : item.cardAvaliacao.status === 'Concluída' ? 'var(--Green2)' : item.cardAvaliacao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
              {item.cardAvaliacao.status}
            </Flex>
          </Flex>
          <Flex gap={'1rem'} justifyContent={'center'} color={'var(--Azul)'} flexWrap='wrap' width={'100%'}>
              {
                  item.cardAvaliacao.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).map((e, i) => {
                    return (
                      <Flex flexDir={'column'} fontSize={'1rem'} alignItems={'center'} opacity={(e.respondidos === 0 && e.total === 0) ? '.5' : ''} cursor={(e.respondidos === 0 && e.total === 0) ? 'not-allowed' : ''}borderRight={item.cardAvaliacao.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).length !== (i + 1) ? '2px dashed var(--AzulOpaco)' : ''} p={item.cardAvaliacao.eixosRespondentes.filter(e => e.tipoAvaliador !== 7).length !== (i + 1) ? '0 1.25rem 0 .75rem' : '0 0 0 .75rem'} pl={i === 0 ? '0' : undefined} gap={'.325rem'}>
                          <Flex alignItems={'center'} gap={'.325rem'}>
                              {getIcon(e.tipoAvaliador)}
                              <strong>{e.respondidos}/{e.total}</strong>
                          </Flex>
                          <strong style={{ color: 'black' }}>{getName(e.tipoAvaliador)}</strong>
                      </Flex>
                    )
                  })
              }
          </Flex>
          <Flex justifyContent={'space-between'} width={'100%'}>
            <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
            <Flex gap={'1rem'} alignItems={'center'} fontSize='14px'>
              <Flex gap={'.125rem'} fontWeight={400}>Avaliações concluídas: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.cardAvaliacao.concluidas}</strong>/<strong>{item.cardAvaliacao.total}</strong></Flex>
              <ElementoTooltipCmp bg={'var(--Green2)'} label={'Ver mais'}>
                <ButtonCmp small onClick={() => setAvaliacoesIndividuais(item.cardAvaliacao.avaliacoesIndividuais)} VarColor='Green2'><FaEye /></ButtonCmp>
              </ElementoTooltipCmp>
              {(item.cardAvaliacao.avaliacoesIndividuais.some(a => a.encerrada)) && <ElementoTooltipCmp label='Visualizar resultados' bg={'var(--Rosa)'}>
                <ButtonCmp onClick={() => navigate(`/Desempenho/AnaliseDesempenho/${modoPesquisa}/ResultadoPesquisa/${item.cardAvaliacao.pesquisaId}`)} VarColor={'Rosa'}><FaTachometerAlt size={'14'}/></ButtonCmp>
              </ElementoTooltipCmp>}
              {(parseJwt().adm === 'True') && <ElementoTooltipCmp label='Baixar status preenchimento' bg={'var(--Rosa)'}>
                <ButtonCmp onClick={() => redirectPage(`${urlApi}/AvaliacaoPesquisa/${item.cardAvaliacao.pesquisaId}/statusCsv/?token=${localStorage.getItem('token') as string}`) } VarColor={'Rosa'}><FaCloudDownloadAlt size={'14'}/></ButtonCmp>
              </ElementoTooltipCmp>}
              {(parseJwt().adm === 'True') && <ElementoTooltipCmp label='Gestão de participantes' bg={'var(--Rosa)'}>
                <ButtonCmp onClick={() => navigate(`/Desempenho/AnaliseDesempenho/${modoPesquisa}/Participantes/${item.cardAvaliacao.pesquisaId}/Editar`)} VarColor={'Rosa'}><FaUsers size={'14'}/></ButtonCmp>
              </ElementoTooltipCmp>}
              {(item.cardAvaliacao.avaliacoesIndividuais.some(e => !e.encerrada) && parseJwt().adm === 'True') && <ElementoTooltipCmp label='Configurações de envio' bg={'var(--Rosa)'}>
                <ButtonCmp onClick={() => navigate(`/Desempenho/AnaliseDesempenho/${modoPesquisa}/EnviarPesquisa/${item.cardAvaliacao.pesquisaId}/Editar`)} VarColor={'Rosa'}><MdSend size={'14'}/></ButtonCmp>
              </ElementoTooltipCmp>}
              {(parseJwt().adm === 'True') && <ElementoTooltipCmp label='Visualizar formulário' bg={'var(--Rosa)'}>
                <ButtonCmp onClick={() => navigate(`/Desempenho/AnaliseDesempenho/${modoPesquisa}/VisualizarFormulario/${item.cardAvaliacao.pesquisaId}?leitura=true`)} VarColor={'Rosa'}><FaWpforms size={'14'}/></ButtonCmp>
              </ElementoTooltipCmp>}
            </Flex>
          </Flex>
        </Flex>
      case 5:
      case 15:
        return <Flex
        minW={'100%'}
        h={`${height}px`}
        transition='all 0.3s ease'
        border='1px solid var(--Azul)'
        borderRadius={'.25rem'}
        bg='white'
        flexDir={'column'}
        gap={'.75rem'}
        p={'.75rem 4.5rem'}
        boxSizing={'border-box'}
      >
        <Flex justifyContent={'space-between'} w={'full'}>
          <Flex gap={'.625rem'} alignItems={'center'}>
            {GetIconByTipoItem(item.tipo, 24)}
            <Flex flexDir={'column'} lineHeight={'14px'}>
              <h3>{item.cardFormulario.nome}</h3>
              <Text fontSize={'13px'} fontWeight={400}>{GetNomeItemFeedback(5)}</Text>
            </Flex>
          </Flex>
          <Flex pt={'.325rem'} gap={'.325rem'} alignItems={'center'} h={'fit-content'} fontSize={'14px'} color={item.cardFormulario.status === 'Aguardando início' ? 'var(--c6)' : item.cardFormulario.status === 'Concluída' ? 'var(--Green2)' : item.cardFormulario.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
            <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.cardFormulario.status === 'Aguardando início' ? 'var(--c6)' : item.cardFormulario.status === 'Concluída' ? 'var(--Green2)' : item.cardFormulario.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
            {item.cardFormulario.status}
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex gap={'1rem'} justifyContent={'center'} color={'var(--Azul)'} flexWrap='wrap' width={'100%'}>
            {item.tipo !== 15 && item.cardFormulario.gestorTotal && <Flex flexDir={'column'} fontSize={'1rem'} alignItems={'center'} borderRight={'2px dashed var(--AzulOpaco)'} pr={'1rem'} gap={'.325rem'}>
                  <Flex alignItems={'center'} gap={'.325rem'}>
                      {getIcon(1)}
                      <strong>{item.cardFormulario.gestorRespondido}/{item.cardFormulario.gestorTotal}</strong>
                  </Flex>
                  <strong style={{ color: 'black' }}>{getName(1)}</strong>
            </Flex>}
            <Flex flexDir={'column'} fontSize={'1rem'} p={'0 .75rem 0 0'} alignItems={'center'} gap={'.325rem'}>
                <Flex alignItems={'center'} gap={'.325rem'}>
                    {getIcon(0)}
                    <strong>{item.cardFormulario.participanteRespondido}/{item.cardFormulario.participanteTotal}</strong>
                </Flex>
                <strong style={{ color: 'black' }}>Participante</strong>
            </Flex>
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
          <Flex gap={'1rem'} alignItems={'center'}>
            <Flex gap={'.125rem'} fontWeight={400} fontSize={'14px'} mr={'1rem'}>Formulários preenchidos: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.cardFormulario.respondidas}</strong>/<strong>{item.cardFormulario.total}</strong></Flex>
            <ButtonCmp onClick={() => {
              setAvaliacoesIndividuais(item.cardFormulario.respondentes.map(e => {
                const eixosRespondentes = [{ respondidos: e.participanteRespondeu ? 1 : 0, tipoAvaliador: 0, total: 1 }]
                if (item.tipo !== 15 && item.cardFormulario.gestorTotal) eixosRespondentes.push({ respondidos: e.responsavelRespondeu ? 1 : 0, tipoAvaliador: 1, total: 1 })
                return { eixosRespondentes: eixosRespondentes, nome: '', concluidas: 0, encerrada: e.participanteRespondeu && (item.tipo === 15 || e.responsavelRespondeu), avaliacoesIndividuais: [], total: 0, colaborador: e.participante, pesquisaId: '', status: '' }
              }))
              setIsForm(true)
            }} VarColor='Green2'><FaEye /></ButtonCmp>
            {
                (parseJwt().adm === 'True') && (
                    <ElementoTooltipCmp bg={'var(--Rosa)'} label={'Gestão de envios'}>
                      <ButtonCmp VarColor='Rosa' onClick={() => navigate(`/Jornada/PesquisaInterna/Convites/${item.cardFormulario.id}?feedbackId=${feedbackId ?? ''}`)
                        }>
                          <FaEnvelope/>
                      </ButtonCmp>
                    </ElementoTooltipCmp>
                )
            }
            {
                (item.cardFormulario.respondidas > 0) &&
                <ElementoTooltipCmp bg={'var(--Rosa)'} label={'Resultado'}>
                  <ButtonCmp VarColor='Rosa' onClick={() => navigate(`/Jornada/PesquisaInterna/Resultado/${item.cardFormulario.id}?feedbackId=${feedbackId ?? ''}`)}>
                      <FaChartPie/>
                  </ButtonCmp>
                </ElementoTooltipCmp>
            }
            {
            (parseJwt().adm === 'True' && item.cardFormulario.respondidas > 0) &&
              <ElementoTooltipCmp bg={'var(--Rosa)'} label={'Baixar base'}>
                <ButtonCmp VarColor='Rosa' onClick={() => window.location.href = `${urlApi}/PesquisaInterna/Csv?pesquisaId=${item.cardFormulario.id}&token=${ObterToken()}&feedbackId=${feedbackId ?? ''}`}>
                  <FaFileCsv/>
                </ButtonCmp>
              </ElementoTooltipCmp>
            }
          </Flex>
        </Flex>
      </Flex>
      case 11:
        return <Flex
        minW={'100%'}
        h={`${height}px`}
        transition='all 0.3s ease'
        border='1px solid var(--Azul)'
        borderRadius={'.25rem'}
        bg='white'
        flexDir={'column'}
        gap={'.75rem'}
        p={'.75rem 4.5rem'}
        boxSizing={'border-box'}
      >
        <Flex justifyContent={'space-between'} w={'full'} h={'full'}>
          <Flex gap={'.625rem'} alignItems={'center'} h={'fit-content'}>
            {GetIconByTipoItem(item.tipo, 24)}
            <Flex flexDir={'column'} lineHeight={'14px'}>
              <h3>{item.cardReuniao.nome}</h3>
              <Text fontSize={'13px'} fontWeight={400}>{GetNomeItemFeedback(11)}</Text>
            </Flex>
          </Flex>
          <Flex gap={'.325rem'} alignItems={'center'} h={'fit-content'} pt={'.325rem'} fontSize={'14px'} color={item.cardReuniao.status === 'Aguardando início' ? 'var(--c6)' : item.cardReuniao.status === 'Concluída' ? 'var(--Green2)' : item.cardReuniao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
            <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.cardReuniao.status === 'Aguardando início' ? 'var(--c6)' : item.cardReuniao.status === 'Concluída' ? 'var(--Green2)' : item.cardReuniao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
            {item.cardReuniao.status}
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
          <Flex gap={'1rem'} alignItems={'center'}>
            <Flex gap={'.125rem'} fontWeight={400} fontSize={'14px'} mr={'1rem'}>Reuniões realizadas: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.cardReuniao.realizadas}</strong>/<strong>{item.cardReuniao.total}</strong></Flex>
            <ButtonCmp onClick={() => setReunioes(item.cardReuniao.reunioesPendentes)} VarColor='Green2' leftIcon={<FaEye />}>Ver mais</ButtonCmp>
          </Flex>
        </Flex>
      </Flex>
      case 13:
        return <Flex
        minW={'100%'}
        h={`${height}px`}
        transition='all 0.3s ease'
        border='1px solid var(--Azul)'
        borderRadius={'.25rem'}
        bg='white'
        flexDir={'column'}
        gap={'.75rem'}
        p={'.75rem 4.5rem'}
        boxSizing={'border-box'}
      >
        <Flex justifyContent={'space-between'} w={'full'} h={'full'}>
          <Flex gap={'.625rem'} alignItems={'center'} h={'fit-content'}>
            {GetIconByTipoItem(item.tipo, 24)}
            <Flex flexDir={'column'} lineHeight={'14px'}>
              <h3>{item.cardCalibracao.nome}</h3>
              <Text fontSize={'13px'} fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
            </Flex>
          </Flex>
          <Flex gap={'.325rem'} alignItems={'center'} h={'fit-content'} pt={'.325rem'} fontSize={'14px'} color={item.cardCalibracao.status === 'Aguardando início' ? 'var(--c6)' : item.cardCalibracao.status === 'Concluída' ? 'var(--Green2)' : item.cardCalibracao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
            <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.cardCalibracao.status === 'Aguardando início' ? 'var(--c6)' : item.cardCalibracao.status === 'Concluída' ? 'var(--Green2)' : item.cardCalibracao.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
            {item.cardCalibracao.status}
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
          <Flex gap={'1rem'} alignItems={'center'}>
            <Flex gap={'.125rem'} fontWeight={400} fontSize={'14px'} mr={'1rem'}>Calibrações realizadas: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.cardCalibracao.calibradas}</strong>/<strong>{item.cardCalibracao.total}</strong></Flex>
            <ButtonCmp onClick={() => setCalibracoes(item.cardCalibracao.calibracoes)} VarColor='Green2' leftIcon={<FaEye />}>Ver mais</ButtonCmp>
          </Flex>
        </Flex>
      </Flex>
      case 12:
        return <Flex
        minW={'100%'}
        h={`${height}px`}
        transition='all 0.3s ease'
        border='1px solid var(--Azul)'
        borderRadius={'.25rem'}
        bg='white'
        flexDir={'column'}
        gap={'.75rem'}
        p={'.75rem 4.5rem'}
        boxSizing={'border-box'}
      >
        <Flex justifyContent={'space-between'} w={'full'} h={'full'}>
          <Flex gap={'.625rem'} alignItems={'center'} h={'fit-content'}>
            {GetIconByTipoItem(item.tipo, 24)}
            <Flex flexDir={'column'} lineHeight={'14px'}>
              <h3>9Box</h3>
              <Text fontSize={'13px'} fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
            </Flex>
          </Flex>
          <Flex gap={'.325rem'} alignItems={'center'} h={'fit-content'} pt={'.325rem'} fontSize={'14px'} color={item.card9Box.status === 'Aguardando início' ? 'var(--c6)' : item.card9Box.status === 'Concluída' ? 'var(--Green2)' : item.card9Box.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
            <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.card9Box.status === 'Aguardando início' ? 'var(--c6)' : item.card9Box.status === 'Concluída' ? 'var(--Green2)' : item.card9Box.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
            {item.card9Box.status}
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
          <Flex gap={'1rem'} alignItems={'center'}>
            <Flex gap={'.125rem'} fontWeight={400} fontSize={'14px'} mr={'1rem'}>Calibrações realizadas: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.card9Box.preenchidos}</strong>/<strong>{item.card9Box.total}</strong></Flex>
            <ButtonCmp onClick={() => setCalibracoes(item.card9Box.lista)} VarColor='Green2' leftIcon={<FaEye />}>Ver mais</ButtonCmp>
          </Flex>
        </Flex>
      </Flex>
      case 14:
        return <Flex
        minW={'100%'}
        h={`${height}px`}
        transition='all 0.3s ease'
        border='1px solid var(--Azul)'
        borderRadius={'.25rem'}
        bg='white'
        flexDir={'column'}
        gap={'.75rem'}
        p={'.75rem 4.5rem'}
        boxSizing={'border-box'}
      >
        <Flex justifyContent={'space-between'} w={'full'} h={'full'}>
          <Flex gap={'.625rem'} alignItems={'center'} h={'fit-content'}>
            {GetIconByTipoItem(item.tipo, 24)}
            <Flex flexDir={'column'} lineHeight={'14px'}>
              <h3>{GetNomeItemFeedback(item.tipo)}</h3>
              <Text fontSize={'13px'} fontWeight={400}>Preenchimento do plano de desenvolvimento</Text>
            </Flex>
          </Flex>
          <Flex gap={'.325rem'} alignItems={'center'} h={'fit-content'} pt={'.325rem'} fontSize={'14px'} color={item.cardPDI.status === 'Aguardando início' ? 'var(--c6)' : item.cardPDI.status === 'Concluída' ? 'var(--Green2)' : item.cardPDI.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'} fontWeight={700} lineHeight={'14px'}>
            <Flex borderRadius={'50%'} w={'10px'} h={'10px'} bg={item.cardPDI.status === 'Aguardando início' ? 'var(--c6)' : item.cardPDI.status === 'Concluída' ? 'var(--Green2)' : item.cardPDI.status === 'Em andamento' ? 'var(--Red)' : 'var(--Orange)'}></Flex>
            {item.cardPDI.status}
          </Flex>
        </Flex>
        <Flex justifyContent={'space-between'} width={'100%'}>
          <Flex alignItems={'end'} w={'18.5rem'} justifyContent='start' fontSize={'12px'} gap={'.325rem'}>Data fim: <strong>{item.dataFim}</strong></Flex>
          <Flex gap={'1rem'} alignItems={'center'}>
            <Flex gap={'.125rem'} fontWeight={400} fontSize={'14px'} mr={'1rem'}>PDIs preenchidos: <strong style={{ marginLeft: '.375rem', color: 'var(--Green2)' }}>{item.cardPDI.preenchidos}</strong>/<strong>{item.cardPDI.total}</strong></Flex>
            <ButtonCmp onClick={() => { setCalibracoes(item.cardPDI.pdis); setIsPDI(true) }} VarColor='Green2' leftIcon={<FaEye />}>Ver mais</ButtonCmp>
          </Flex>
        </Flex>
      </Flex>
      default:
        return <Flex minW={'100%'}></Flex>
    }
  }

  return (
    <Flex
      position='relative'
      overflow='hidden'
      w='100%'
      h={`${height}px`}
      align='center'
      justify='center'
    >
      {AvaliacoesIndividuais && <ModalAvaliacoes
        isOpen
        avaliacoes={AvaliacoesIndividuais}
        isForm={IsForm}
        onRequestClose={() => { setAvaliacoesIndividuais(undefined); setIsForm(false) }}
      />}
      {Reunioes && <ModalReunioes
        isOpen
        reunioes={Reunioes}
        onRequestClose={() => { setReunioes(undefined) }}
      />}
      {Calibracoes && <ModalCalibracoes
        isOpen
        calibracoes={Calibracoes}
        isPDI={IsPDI}
        onRequestClose={() => { setCalibracoes(undefined); setIsPDI(false) }}
      />}
      <Flex
        as={motion.div}
        w={`${100}%`}
        animate={{ x: `-${(100 * ordem)}%` }}
        transition={'0.3s ease-out'}
      >
        {items.map((item, i) => (
          ReturnItem(item)
        ))}
      </Flex>

      <IconButton
        icon={<MdChevronLeft />}
        aria-label='Previous'
        position='absolute'
        bg={'var(--Azul)'}
        color={'var(--c1)'}
        _hover={{ bg: 'var(--Azul-hover)' }}
        left={2}
        onClick={handlePrev}
        variant='ghost'
      />
      <IconButton
        icon={<MdChevronRight />}
        aria-label='Next'
        position='absolute'
        bg={'var(--Azul)'}
        color={'var(--c1)'}
        _hover={{ bg: 'var(--Azul-hover)' }}
        right={2}
        onClick={handleNext}
        variant='ghost'
      />
    </Flex>
  )
}
